import React, { useState, useEffect } from 'react';
import { Div, CenterRowDiv, RowDiv, Text } from 'styles';
import { Button, Icon, Img, InfoDiv, Input, LineText, Modal, Radio, SubTitle, Switch } from 'components';
import { useImmer } from 'use-immer';
import { Spinner } from 'components/loading/Spinner';
import { findIndex } from 'lodash';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { FormikInput } from 'components/form/input/FormikInput';
import useAlertContext from 'hooks/useAlertContext';
import houseActuatorService from 'services/house/house-actuator-service';

function ModalActuatorWindowDetail({open, setOpen, title, id, afterCancel, afterSubmit}) {
  const { alert } = useAlertContext();

  const [loading, setLoading] = useState(false);
  const [canEdit, setCanEdit] = useState(false);
  const [selectedRadio, setSelectedRadio] = useState('power');

  const [schema, setSchema] = useState(null);

  const handleOnSubmit = async (values) => {
    setLoading(true);

    let updateResponse = null;

    let isSuccess = true;

    try {
      // if (selectedRadio === 'power') {
        updateResponse = await houseActuatorService.updateHouseWindowPower(id, values.powerValue);
        console.log('윈도우 리스폰스!!!', updateResponse)
        if(updateResponse.result === 'fail'){
          isSuccess = false;
        }
      // } 
      // else if (selectedRadio === 'value') {


      //   let errorMessage = '';
      //   let opentempInput = values.openTemp;
        
      //   const opentempRegex = /^-?\d+(\.\d+)?$/; // 숫자와 소수점만 허용하는 정규식


      //   if (!opentempInput || opentempInput === '-' || opentempInput < 18 || opentempInput > 30 || !opentempRegex.test(opentempInput)) {
      //       errorMessage += `열림 온도 입력은 18에서 30 사이의 유효한 숫자여야 하며, 숫자와 소수점 이외의 문자가 포함될 수 없습니다.\n`;

      //   }
      //   if (typeof opentempInput !== 'string') {
      //     opentempInput = opentempInput?.toString() || '';
      //   }
      //   if (!opentempInput.includes('.')) {
      //     // 온도 값이 정수일 경우 소수점 추가
      //     opentempInput = `${opentempInput}.0`;

          
      //   }

      //   let closetempInput = values.closeTemp;
      //   const closetempRegex = /^-?\d+(\.\d+)?$/; // 숫자와 소수점만 허용하는 정규식


      //   if (!closetempInput || closetempInput === '-' || closetempInput < 18 || closetempInput > 30 || !closetempRegex.test(closetempInput)) {
      //       errorMessage += `닫힘 온도 입력은 18에서 30 사이의 유효한 숫자여야 하며, 숫자와 소수점 이외의 문자가 포함될 수 없습니다.\n`;
      //   }
      //   if (typeof closetempInput !== 'string') {
      //     closetempInput = closetempInput?.toString() || '';
      //   }
      //   if (!closetempInput.includes('.')) {
      //     // 온도 값이 정수일 경우 소수점 추가
      //     closetempInput = `${closetempInput}.0`;

      //   }

      //   if (errorMessage) {
      //     alert({
      //       type: 'alert',
      //       title: '입력 오류',
      //       content: errorMessage,
      //     });
      //     setLoading(false);
      //     return;
      //   }

      //   const updateOpenTempResponse = await houseActuatorService.updateHouseWindowTemp(id, '1', values.openTemp);
      //   const updateCloseTempResponse = await houseActuatorService.updateHouseWindowTemp(id, '2', values.closeTemp);
      //   const updateModeResponse = await houseActuatorService.updateHouseWindowMode(id);

      //   if(updateOpenTempResponse.result === 'fail'){
      //     isSuccess = false;
      //   }
      //   if(updateCloseTempResponse.result === 'fail'){
      //     isSuccess = false;
      //   }
      //   if(updateModeResponse.result === 'fail'){
      //     isSuccess = false;
      //   }
        
      //   // updateResponse.result = updateOpenTempResponse.result === 'success' && updateCloseTempResponse.result === 'success' ? 'success' : 'fail';

      //   // updateResponse.error_message = updateOpenTempResponse.error_message || updateCloseTempResponse.error_message;
      // }
      
    } catch (e) {
      console.error(e);
    }

    // if (updateResponse.result === 'success') {
      if (isSuccess) {
      const message = selectedRadio === 'power' ?
        '장비 제어가 정상 수행되었습니다.'
        :
        '장비 제어가 정상 수행되었습니다.';

      alert({
        type: 'alert',
        title: 'Info',
        content: message,
        okCallback: () => {
          setOpen(false);
      
          if (afterSubmit) {
            afterSubmit();
          }
        }
      })
    } else {
      let errorMessage = selectedRadio === 'power' ?
        '장비 제어시 에러가 발생했습니다.'
        :
        '장비 제어시 에러가 발생했습니다.';

      if (updateResponse && updateResponse.error_message) {
        errorMessage += `(${updateResponse.error_message})`;
      }

      alert({
        type: 'alert',
        title: 'Error',
        content: errorMessage
      })
    }

    setLoading(false);
  };
  
  const formik = useFormik({
    initialValues: {
      powerValue: 0,
      openTemp: 0,
      closeTemp: 0,
    },
    validationSchema: schema,
    onSubmit: handleOnSubmit,
  });

  const radioOnChange = async (val, id) => {
    setSelectedRadio(val);
    
    if (val === 'power') {
      setSchema(null);
      formik.setFieldError('openTemp', null);
      formik.setFieldError('closeTemp', null);
      formik.setFieldTouched('openTemp', false, true);
      formik.setFieldTouched('closeTemp', false, true);
      let data = null;
      data = await houseActuatorService.getHouseActuatorDetail(id);
      const sensorValue = data[0].sensor_value;
      formik.setFieldValue('powerValue', sensorValue === 1 ? '1' : '0', true);
    } else if (val === 'value') {
      setSchema(yup.object().shape({
        openTemp: yup.number()
            .required('필수 입력항목 입니다.')
            .min(18, '입력값이 18 와 30 사이에 있어야합니다.')
            .max(30, '입력값이 18 와 30 사이에 있어야합니다.'),
        closeTemp: yup.number()
            .required('필수 입력항목 입니다.')
            .min(18, '입력값이 18 와 30 사이에 있어야합니다.')
            .max(30, '입력값이 18 와 30 사이에 있어야합니다.')
      }));
      const getWindowControllTemp = await houseActuatorService.getWindowControllTemp(id);

      if (getWindowControllTemp && getWindowControllTemp.length > 0) {
          getWindowControllTemp.forEach((item) => {
              if (item.length > 0) {
                  const sensorType = item[0].sensor_type;
                  const sensorTemp = item[0].sensor_value;
                  const formattedValue = formatTemperature(sensorTemp);

                  if (sensorType.includes('OPEN')) {
                      formik.setFieldValue('openTemp', formattedValue, true);
                  } else if (sensorType.includes('CLOSE')) {
                      formik.setFieldValue('closeTemp', formattedValue, true);
                  }
              }
          });
      } else {
          alert('온도 데이터가 없습니다.');
      }


    }
  };

  // 온도 포맷팅 함수: 뒤에서 첫 번째와 두 번째 숫자 사이에 '.' 추가
  function formatTemperature(value) {
    const tempStr = value.toString();
    if (tempStr.length >= 2) {
      return `${tempStr.slice(0, -1)}.${tempStr.slice(-1)}`;
    }
    return tempStr; // 기본 반환
  }

  useEffect(() => {
    setLoading(true);
    setCanEdit(false);

    const getActuatorDetail = async () => {
        await formik.setFieldValue('powerValue', '', true);
        await formik.setFieldValue('openTemp', '', true);
        await formik.setFieldValue('closeTemp', '', true);
        await formik.resetForm();

        let data = null;

        try {
            // 데이터 가져오기
            data = await houseActuatorService.getHouseActuatorDetail(id);

            // 열림/닫힘 온도 가져오기
            if (data !== null && data.length > 0) {
                const sensorValue = data[0].sensor_value;

                if (sensorValue === 2) {
                    // "value" 옵션 선택
                    setSelectedRadio('value');

                    // 열림/닫힘 온도 설정
                    const getWindowControllTemp = await houseActuatorService.getWindowControllTemp(id);

                    if (getWindowControllTemp && getWindowControllTemp.length > 0) {
                        getWindowControllTemp.forEach((item) => {
                            if (item.length > 0) {
                                const sensorType = item[0].sensor_type;
                                const sensorTemp = item[0].sensor_value;
                                const formattedValue = formatTemperature(sensorTemp);

                                if (sensorType.includes('OPEN')) {
                                    formik.setFieldValue('openTemp', formattedValue, true);
                                } else if (sensorType.includes('CLOSE')) {
                                    formik.setFieldValue('closeTemp', formattedValue, true);
                                }
                            }
                        });
                    } else {
                        alert('온도 데이터가 없습니다.');
                    }
                } else {
                    // "power" 옵션 선택
                    setSelectedRadio('power');
                    formik.setFieldValue('powerValue', sensorValue === 1 ? '1' : '0', true);
                }

                setCanEdit(true);
            } else {
                setCanEdit(false);
            }
        } catch (e) {
            console.error(e);
        }

        setLoading(false);
    };

    getActuatorDetail();
}, [open]);

  return (
    <Modal open={open} title={title} cancel={() => {
      setOpen(false);
      
      if (afterCancel) {
        afterCancel();
      }
    }} submit={() => {
      if (!loading && canEdit) {
        formik.submitForm();
      }
    }}>
      <form onSubmit={formik.handleSubmit}>
        {/* <Radio
            name="controlOption"
            value="power"
            checked={selectedRadio === 'power'}
            // onChange={radioOnChange}
            onChange={() => radioOnChange('power', id)}
            $marginBottom={24}
            $height={30}
            $alignItems="center"
          > */}
            <RowDiv $justifyContent="space-between" $alignItems="center" $flex={1}>
              <Text>상태</Text>
              <Switch
                name="powerValue"
                filters={{type: formik.values.powerValue}}
                onChange={(name, value) => {
                  formik.setFieldValue('powerValue', value, true)
                }}
                $line
                list={[
                  { name: '열림', val: '1' },
                  { name: '닫힘', val: '0' },
                  // { name: '자동', val: '2' },
                ]}
                // disabled={selectedRadio !== 'power'}
              />
            </RowDiv>
          {/* </Radio> */}
          {/* <Radio
            name="controlOption"
            value="value"
            checked={selectedRadio === 'value'}
            // onChange={radioOnChange}
            onChange={() => radioOnChange('value', id)}
            $alignItems="flex-start"
          >
            <Div $flex={1}>
              <FormikInput
                type="number"
                $default
                label="장비제어조건 열림온도 설정"
                name="openTemp"
                value={formik.values.openTemp}
                placeholder="온도값 입력"
                unit="°C"
                $invalid={formik.errors.openTemp}
                $touch={formik.touched.openTemp}
                $invalidText={formik.errors.openTemp}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={selectedRadio !== 'value'}
              />
              <Div $marginTop="10px">
                <FormikInput
                  $padding="10px"
                  type="number"
                  $default
                  label="장비제어조건 닫힘온도 설정"
                  name="closeTemp"
                  value={formik.values.closeTemp}
                  placeholder="온도값 입력"
                  unit="°C"
                  $invalid={formik.errors.closeTemp}
                  $touch={formik.touched.closeTemp}
                  $invalidText={formik.errors.closeTemp}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={selectedRadio !== 'value'}
                />
              </Div>
            </Div>
          </Radio> */}
        
        { loading && (
          <CenterRowDiv $justifyContent="center" $marginTop="20px">
            <Spinner $width={25} $height={25}/>
          </CenterRowDiv>
          )
        }
      </form>
    </Modal>
  )
}

export default ModalActuatorWindowDetail